import { IServerSideGetRowsParams } from 'ag-grid-community';


type SSMResult<T> =T[] | {rows: T[]; count: number}
type GetRowsCallback<T> = (params: IServerSideGetRowsParams) => Promise<SSMResult<T>>;

export async function processSSRM<T>(
  params: IServerSideGetRowsParams,
  callback: GetRowsCallback<T>,
) {
  const result = await callback(params);

  // Supports T[] or { rows, count }
  const rows = Array.isArray(result) ? result : result.rows;
  const count = Array.isArray(result) ? undefined : result.count;

  if (!rows?.length) {
    params.api.showNoRowsOverlay();
  } else {
    params.api.hideOverlay();
  }

  if (typeof count === "number") {
    params.success({
      rowData: rows,
      rowCount: count,
    });
    return;
  }

  params.success({
    rowData: rows,
  });
}
